import { HIDE_MESSAGE, SHOW_MESSAGE } from "../../constants/ActionTypes";

const INIT_STATE = {
  messages: [],
};

const NotificationReducer = (state, action) => {
  state = state || INIT_STATE;
  const { type, payload } = action;

  const removeMessage = () => {
    const { messages } = state;
    for (let i = 0; i < messages.length; i++) {
      if (messages[i].id === payload) {
        return {
          ...state,
          messages: [...messages.slice(0, i), ...messages.slice(i + 1)],
        };
      }
    }
    return state;
  };

  switch (type) {
    case SHOW_MESSAGE:
      return { ...state, messages: [payload, ...state.messages] };

    case HIDE_MESSAGE:
      return removeMessage();

    default:
      return state;
  }
};

export default NotificationReducer;
